// German for the review queue. The shared review verbs (Übernehmen · übernommen · angepasst ·
// abgelehnt · nicht übernommen), the refusal reasons in their snake_case form, 'Overview',
// 'Cancel', 'not collected' and the page title itself live in the common catalogue and in
// registry.de.ts — repeating them here with a different word would warn and be ignored.
//
// Swiss German orthography: ss, never ß.
import { registerDe } from '../i18n/index.js';

registerDe({
  // ── the masthead ──
  'what the agents proposed and nobody has held yet':
    'was die Agenten vorgeschlagen haben und noch niemand übernommen hat',
  'nothing becomes a fact, a touchpoint or a sent mail without a click here':
    'ohne einen Klick hier wird nichts zu einem Fakt, einem Kontaktpunkt oder einer gesendeten Mail',
  'j/k · a hold · e amend · r refuse · u undo':
    'j/k · a übernehmen · e anpassen · r ablehnen · u rückgängig',
  'j moves down · k moves up · a holds · e amends · r refuses · u undoes':
    'j nach unten · k nach oben · a übernimmt · e passt an · r lehnt ab · u macht rückgängig',
  'Hold all {n}': 'Alle {n} übernehmen',
  'Hold every unheld claim this list matches, across every page; a row the record already answers stays, with the reason on it':
    'Jede nicht übernommene Aussage, die diese Liste trifft, über alle Seiten übernehmen; eine Zeile, die der Datenbestand bereits beantwortet, bleibt stehen, mit dem Grund daran',
  'Holding… {held} of {total}': 'Übernehme … {held} von {total}',
  '{held} held': '{held} übernommen',
  '{left} left — the record already answers them; the reason is on each row':
    '{left} belassen – der Datenbestand beantwortet sie bereits; der Grund steht an jeder Zeile',
  '{failed} refused the write': '{failed} verweigerten den Schreibvorgang',
  '{n} from a source stay for their own Hold all': '{n} aus einer Quelle bleiben für ihr eigenes «Alle übernehmen»',
  '{n} need a person (drafts, dedupes, rule changes)': '{n} brauchen einen Menschen (Entwürfe, Dubletten, Regeländerungen)',
  'Hold all stopped. What was held stays held; nothing else was written.':
    '«Alle übernehmen» ist stehen geblieben. Was übernommen wurde, bleibt übernommen; sonst wurde nichts geschrieben.',
  'Refusal log →': 'Ablehnungsprotokoll →',

  // ── the rail ──
  'Held · 7d': 'Übernommen · 7 T',
  'Refused · 7d': 'Abgelehnt · 7 T',
  'Edit distance': 'Änderungsdistanz',
  'Hot run': 'Auffälliger Lauf',
  'Open the desk of the run that filed this': 'Den Arbeitsplatz des Laufs öffnen, der dies eingereicht hat',
  'oldest {date} · from {n} principals': 'ältestes {date} · von {n} Prinzipalen',
  'the queue is empty': 'die Warteschlange ist leer',
  'the summary has not answered yet': 'die Zusammenfassung hat noch nicht geantwortet',
  '{filed} as filed · {amended} amended': '{filed} wie eingereicht · {amended} angepasst',
  'no refusal in the last seven days': 'keine Ablehnung in den letzten sieben Tagen',
  'how far your holds moved from the filed text':
    'wie weit Ihre Übernahmen vom eingereichten Text abwichen',
  'nothing has been amended yet, so there is no distance to measure':
    'es wurde noch nichts angepasst, also gibt es keine Distanz zu messen',
  'no run has filed anything yet': 'noch kein Lauf hat etwas eingereicht',
  '{n}% pushed back': '{n}% zurückgewiesen',
  '{principal} · {filed} filed · {refused} refused': '{principal} · {filed} eingereicht · {refused} abgelehnt',

  // ── the rail of claims ──
  'The queue': 'Die Warteschlange',
  'Untreated': 'Unbehandelt',
  'Treated': 'Behandelt',
  '{n} of {total}': '{n} von {total}',
  'clean': 'sauber',
  'collides': 'kollidiert',
  'no evidence': 'kein Beleg',
  'not on record': 'nicht erfasst',
  'Nothing is waiting for you': 'Es wartet nichts auf Sie',
  'Nothing has been treated yet': 'Es wurde noch nichts behandelt',
  'A row appears here when an agent, a monitor or the seed importer files a proposal. Nothing writes to the record without passing through this queue.':
    'Eine Zeile erscheint hier, sobald ein Agent, ein Monitor oder der Seed-Import einen Vorschlag einreicht. Nichts wird erfasst, ohne diese Warteschlange zu durchlaufen.',
  'The filter on this list excludes every claim. There are claims — just not these.':
    'Der Filter dieser Liste schliesst jede Aussage aus. Es gibt Aussagen — nur nicht diese.',
  'The queue could not be read': 'Die Warteschlange konnte nicht gelesen werden',
  'This claim could not be read': 'Diese Aussage konnte nicht gelesen werden',
  'Choose a claim on the left.': 'Wählen Sie links eine Aussage.',

  // ── the kinds ──
  'fact': 'Fakt',
  'affiliation': 'Zugehörigkeit',
  'touchpoint': 'Kontaktpunkt',
  'commitment': 'Zusage',
  'persona': 'Persona',
  'draft mail': 'Mail-Entwurf',
  'candidate person': 'Kandidatin oder Kandidat',
  'signal action': 'Signal-Massnahme',
  'rule change': 'Regeländerung',
  'update': 'Aktualisierung',
  'new': 'neu',
  'current role': 'aktuelle Rolle',
  'past role': 'frühere Rolle',
  'mail in': 'Mail ein',
  'mail out': 'Mail aus',
  'meeting': 'Termin',
  'call': 'Anruf',
  'note': 'Notiz',
  'post': 'Beitrag',
  'signal': 'Signal',
  'no descriptor was filed': 'es wurde keine Beschreibung eingereicht',

  // ── the stand ──
  'filed by': 'eingereicht von',
  'on': 'am',
  'collides with a held value': 'kollidiert mit einem übernommenen Wert',
  'not checked against the record': 'nicht gegen den Bestand geprüft',
  'What would enter the record': 'Was in den Bestand käme',
  'a new row': 'eine neue Zeile',
  // ── round 6: the chained hold ──
  'Holds also': 'Übernimmt auch',
  'pending': 'ausstehend',
  '{n} proposal waits on this': '{n} Vorschlag wartet darauf',
  '{n} proposals wait on this': '{n} Vorschläge warten darauf',
  'Also held first: {list}.': 'Zuerst übernommen: {list}.',
  'also held': 'auch übernommen',
  '(the undo does not walk it back)': '(das Rückgängig holt es nicht zurück)',
  'The filing carries no readable field.': 'Die Einreichung enthält kein lesbares Feld.',
  'What you hold is what is written; the filed text stays beside it in the ledger.':
    'Was Sie übernehmen, wird geschrieben; der eingereichte Text bleibt daneben im Journal stehen.',
  'filed {date}': 'eingereicht {date}',
  'would mint': 'vergäbe',

  'Validation': 'Prüfung',
  'PASS': 'OK',
  'WARN': 'ACHTUNG',
  'The filing carries {n} piece of evidence.': 'Die Einreichung führt {n} Beleg mit.',
  'The filing carries {n} pieces of evidence.': 'Die Einreichung führt {n} Belege mit.',
  'Nothing was cited. This claim is asserted, not evidenced.':
    'Es wurde nichts zitiert. Diese Aussage ist behauptet, nicht belegt.',
  'Every citation names its source or quotes it verbatim.':
    'Jedes Zitat nennt seine Quelle oder gibt sie wörtlich wieder.',
  'The evidence names no source and quotes nothing.': 'Der Beleg nennt keine Quelle und zitiert nichts.',
  'The filing carries every field the write needs.':
    'Die Einreichung enthält jedes Feld, das der Schreibvorgang braucht.',
  'The filing is missing {fields}. Holding it would be refused.':
    'Der Einreichung fehlt {fields}. Eine Übernahme würde abgewiesen.',
  'A {kind} write is registered; holding this performs it.':
    'Ein Schreibvorgang für {kind} ist registriert; die Übernahme führt ihn aus.',
  'Nothing can hold a {kind} proposal yet. Nothing would be written.':
    'Ein Vorschlag der Art {kind} kann noch nicht übernommen werden. Es würde nichts geschrieben.',
  'The record already holds {n} row this would land beside.':
    'Der Bestand hält bereits {n} Zeile, neben der dies landen würde.',
  'The record already holds {n} rows this would land beside.':
    'Der Bestand hält bereits {n} Zeilen, neben denen dies landen würde.',
  'Nothing on the record answers to this yet.': 'Im Bestand entspricht dem noch nichts.',
  'The collision check did not run. This claim has NOT been checked against the record.':
    'Die Kollisionsprüfung lief nicht. Diese Aussage wurde NICHT gegen den Bestand geprüft.',

  'What the record already says': 'Was der Bestand bereits sagt',
  'not checked': 'nicht geprüft',
  '{n} collision': '{n} Kollision',
  '{n} collisions': '{n} Kollisionen',
  'Holding this supersedes it; the old value stays in the history.':
    'Die Übernahme löst ihn ab; der alte Wert bleibt in der Historie.',

  'Evidence': 'Belege',
  '{n} span': '{n} Stelle',
  '{n} spans': '{n} Stellen',
  'no source named': 'keine Quelle genannt',
  'The citation carries a source but no quoted span.':
    'Das Zitat nennt eine Quelle, aber keine wörtliche Stelle.',
  'url': 'URL',
  'snapshot': 'Snapshot',
  'interaction': 'Kontaktpunkt',
  'document': 'Dokument',
  'manual': 'manuell',

  'Why it was proposed': 'Warum es vorgeschlagen wurde',
  'The filing carries no rationale. What stands behind it is the evidence above and nothing else.':
    'Die Einreichung nennt keine Begründung. Dahinter steht der Beleg oben und sonst nichts.',

  'Holding this writes': 'Die Übernahme schreibt',
  '{ref} {key} · one fact revision with its evidence link · one supersession. Nothing else moves.':
    '{ref} {key} · eine Faktenrevision mit ihrem Beleg · eine Ablösung. Sonst bewegt sich nichts.',
  '{ref} {key} · one fact with its evidence link. Nothing else moves.':
    '{ref} {key} · einen Fakt mit seinem Beleg. Sonst bewegt sich nichts.',
  'the proposed affiliation at {org} flips from proposed to held. Nothing else moves.':
    'die vorgeschlagene Zugehörigkeit bei {org} wechselt von vorgeschlagen auf übernommen. Sonst bewegt sich nichts.',
  'one interaction {ref} with its participants. Nothing else moves.':
    'einen Kontaktpunkt {ref} mit seinen Teilnehmenden. Sonst bewegt sich nichts.',
  'one open commitment {ref}, owed by {owner}. Nothing else moves.':
    'eine offene Zusage {ref}, geschuldet von {owner}. Sonst bewegt sich nichts.',
  'one person {ref} with status held. Nothing else moves.':
    'eine Person {ref} mit Status übernommen. Sonst bewegt sich nichts.',
  'one person {ref} with status held, and one held affiliation. Nothing else moves.':
    'eine Person {ref} mit Status übernommen und eine übernommene Zugehörigkeit. Sonst bewegt sich nichts.',
  'one organisation {ref}. Nothing else moves.': 'eine Organisation {ref}. Sonst bewegt sich nichts.',
  'one outbox row, status approved, addressed to {to}. It is not sent — sending is a separate click.':
    'eine Postausgang-Zeile, Status genehmigt, adressiert an {to}. Sie wird nicht gesendet — Senden ist ein eigener Klick.',
  'the signal is stamped dispositioned, and one chained draft proposal is filed for the operator to hold separately. Nothing is sent.':
    'das Signal wird als disponiert markiert, und ein verketteter Entwurfsvorschlag wird eingereicht, den die Bedienperson separat übernimmt. Nichts wird gesendet.',
  'one open commitment {ref}, owed by us, and the signal is stamped dispositioned. Nothing else moves.':
    'eine offene Zusage {ref}, geschuldet von uns, und das Signal wird als disponiert markiert. Sonst bewegt sich nichts.',
  'one open commitment, owed by us, and the signal is stamped dispositioned. Nothing else moves.':
    'eine offene Zusage, geschuldet von uns, und das Signal wird als disponiert markiert. Sonst bewegt sich nichts.',
  'one held personas row with {n} trait(s); any previous held version for this subject is superseded. Nothing else moves.':
    'eine übernommene Personas-Zeile mit {n} Merkmal(en); eine vorherige übernommene Version für dieses Subjekt wird abgelöst. Sonst bewegt sich nichts.',
  'one skill-body file written beside the repo (not into it) and one settings_history row for {target}. Nothing else moves.':
    'eine Skill-Textdatei, geschrieben neben dem Repo (nicht hinein), und eine settings_history-Zeile für {target}. Sonst bewegt sich nichts.',
  'one app_settings row for scoring.rules and one settings_history row; a rescore is queued. Nothing else moves.':
    'eine app_settings-Zeile für scoring.rules und eine settings_history-Zeile; eine Neubewertung wird eingereiht. Sonst bewegt sich nichts.',
  'nothing — no applier is registered for {kind}, so the hold would be refused.':
    'nichts — für {kind} ist kein Schreibvorgang registriert, die Übernahme würde abgewiesen.',

  // ── the foot ──
  'Hold it': 'Übernehmen',
  'Hold both': 'Beide übernehmen',
  'Hold all': 'Alle übernehmen',
  'Amend, then hold': 'Anpassen, dann übernehmen',
  'Hold the amended text': 'Angepassten Text übernehmen',
  'Refuse because': 'Ablehnen weil',
  'a note for the run (optional)': 'eine Notiz für den Lauf (optional)',
  'wrong evidence': 'falscher Beleg',
  'not relevant': 'nicht relevant',
  'out of scope': 'ausserhalb des Umfangs',
  'Delete…': 'Löschen…',
  'Remove the filing from the queue. Only an unheld or refused one may go.':
    'Die Einreichung aus der Warteschlange entfernen. Nur eine nicht übernommene oder abgelehnte darf gehen.',
  'Delete this filing?': 'Diese Einreichung löschen?',
  'Delete it': 'Löschen',
  'The proposal leaves the queue for good, with its payload and its evidence. The audit log keeps what it said. Nothing in the record changes.':
    'Der Vorschlag verlässt die Warteschlange endgültig, mit seiner Nutzlast und seinen Belegen. Das Audit-Protokoll behält, was er sagte. Am Bestand ändert sich nichts.',
  '{i} of {n}': '{i} von {n}',

  // ── the session ledger ──
  'This session': 'Diese Sitzung',
  'what you disposed of since this server started · an undo reaches no further':
    'worüber Sie seit dem Start dieses Servers entschieden haben · weiter reicht ein Rückgängig nicht',
  'undone': 'rückgängig gemacht',

  // ── toasts ──
  'Held. {ref} wrote {applied}.': 'Übernommen. {ref} schrieb {applied}.',
  'Amended and held. {ref} wrote {applied}.': 'Angepasst und übernommen. {ref} schrieb {applied}.',
  'no ref': 'keine Referenz',
  'Refused: {reason}. {ref} wrote nothing.': 'Abgelehnt: {reason}. {ref} schrieb nichts.',
  '{ref} is unheld again.': '{ref} ist wieder nicht übernommen.',
  '{ref} is gone from the queue.': '{ref} ist aus der Warteschlange verschwunden.',
  'The hold failed. Nothing was written.': 'Die Übernahme schlug fehl. Es wurde nichts geschrieben.',
  'The refusal failed.': 'Die Ablehnung schlug fehl.',
  'The undo was refused.': 'Das Rückgängigmachen wurde abgewiesen.',
  'The deletion failed.': 'Das Löschen schlug fehl.',

  // ── round 3: a run's raster cells as one group ──
  'Profile': 'Profil',
  '{n} cell': '{n} Zelle',
  '{n} cells': '{n} Zellen',
  'Hold all cells': 'Alle Zellen übernehmen',
  'Hold every non-colliding cell of this run in one transaction; a cell whose current value differs stays for a per-cell decision': 'Jede nicht kollidierende Zelle dieses Laufs in einer Transaktion übernehmen; eine Zelle, deren aktueller Wert abweicht, bleibt für eine Einzelentscheidung stehen',
  '{held} cells held · {collided} left for a per-cell decision': '{held} Zellen übernommen · {collided} für eine Einzelentscheidung belassen',
  'The group hold failed. Nothing was written.': 'Die Gruppenübernahme ist fehlgeschlagen. Nichts wurde geschrieben.',

  // ── round 6: a source's proposals as one group (BUILD-BRIEF-R6 §5.2) ──
  'source': 'Quelle',
  'Hold every non-colliding proposal of this source in one transaction; a colliding row stays for its own click':
    'Jeden nicht kollidierenden Vorschlag dieser Quelle in einer Transaktion übernehmen; eine kollidierende Zeile bleibt für ihren eigenen Klick stehen',

  // ── round 4: organisation dedupe (the finder proposes, the operator decides) ──
  'dedupe': 'Dublette',
  'merge': 'zusammenführen',
  'relate': 'zuordnen',
  'not a duplicate': 'keine Dublette',
  'the names are near-identical': 'die Namen sind fast identisch',
  'they share a domain': 'sie teilen eine Domain',
  'they carry the same UID': 'sie tragen dieselbe UID',
  'the same people are affiliated to both': 'dieselben Personen sind beiden zugeordnet',
  'one name is already an alias of the other': 'ein Name ist bereits ein Alias des anderen',
  'only punctuation and case differ': 'nur Zeichensetzung und Gross-/Kleinschreibung unterscheiden sich',
  'two rows, side by side': 'zwei Zeilen nebeneinander',
  'survivor': 'bleibende Zeile',
  'parent': 'Muttergesellschaft',
  'child': 'Tochtergesellschaft',
  'domains': 'Domains',
  'UID': 'UID',
  'canton': 'Kanton',
  'open deals': 'offene Geschäfte',
  'facts': 'Fakten',
  'created': 'erfasst',
  'and {n} more': 'und {n} weitere',
  'score': 'Bewertung',
  'operator': 'Operatorin',
  'agent': 'Agent',
  'import': 'Import',
  'The filing does not name a pair.': 'Die Eingabe nennt kein Paar.',
  'The pair could not be read. Neither row is shown, so nothing here should be held.':
    'Das Paar konnte nicht gelesen werden. Keine der beiden Zeilen wird gezeigt, hier sollte nichts übernommen werden.',
  '{n} reason': '{n} Grund',
  '{n} reasons': '{n} Gründe',
  'The finder paired them without saying why. A score is not a reason.':
    'Der Finder hat sie ohne Begründung gepaart. Eine Bewertung ist kein Grund.',
  '{n} affiliation': '{n} Zugehörigkeit',
  '{n} affiliations': '{n} Zugehörigkeiten',
  '{n} interaction': '{n} Kontakt',
  '{n} interactions': '{n} Kontakte',
  '{n} commitment': '{n} Zusage',
  '{n} commitments': '{n} Zusagen',
  '{n} deal': '{n} Geschäft',
  '{n} deals': '{n} Geschäfte',
  '{n} fact': '{n} Sachverhalt',
  '{n} facts': '{n} Sachverhalte',
  'interactions not collected': 'Kontakte nicht erhoben',
  'commitments not collected': 'Zusagen nicht erhoben',
  'everything that points at it': 'alles, was darauf zeigt',
  'Holding this archives {b} into {a}: {moves} move; {bname} becomes an alias of {aname}. This cannot be undone from here; the archived row keeps merged_into.':
    'Die Übernahme archiviert {b} in {a}: {moves} wechseln; {bname} wird zu einem Alias von {aname}. Das lässt sich von hier aus nicht rückgängig machen; die archivierte Zeile behält merged_into.',
  'Holding this sets {b}’s parent to {a}.': 'Die Übernahme setzt die Muttergesellschaft von {b} auf {a}.',
  'Holding this records that the two are not the same and hides the pair from future runs.':
    'Die Übernahme hält fest, dass die beiden nicht dieselbe sind, und blendet das Paar in künftigen Läufen aus.',
  'nothing — the filing does not name a pair, so the hold would be refused.':
    'nichts — die Eingabe nennt kein Paar, die Übernahme würde abgewiesen.',
  'cannot be undone here': 'hier nicht rückgängig zu machen',
  'the archived organisation keeps merged_into': 'die archivierte Organisation behält merged_into',
  'affiliations not collected': 'Zugehörigkeiten nicht erhoben',
  'deals not collected': 'Geschäfte nicht erhoben',
  'facts not collected': 'Fakten nicht erhoben',

  // ── round 3b: the `domain` kind ──
  'domain': 'Domain',
  'found by {source}': 'gefunden durch {source}',
  'harvest': 'Ernte',
  'directory': 'Verzeichnis',
  // ── round 5: the `link` kind ──
  'link': 'Verknüpfung',

  'Holding this sets the website and fetches the logo: {host} is appended to {org}’s domains, and the logo pass runs for it. Nothing else moves.':
'Übernehmen setzt die Website und holt das Logo: {host} wird den Domains von {org} angefügt, und der Logo-Durchgang läuft dafür. Sonst bewegt sich nichts.',

  // ── round 5: the `link` panel (§6.4/§6.6) ──
  '(regime)': '(Regime)',
  'of participants': 'der Teilnehmenden',
  'of revenue': 'des Erträge',
  'estimated': 'geschätzt',
  'read': 'Lesung',
  'declared': 'erklärt',
  'not_found': 'nicht gefunden',
  'the quote does not name the counterpart — check the resolution':
    'das Zitat nennt die Gegenpartei nicht — Zuordnung prüfen',
  'the quote does not name the subject — check the resolution':
    'das Zitat nennt die Organisation nicht — Zuordnung prüfen',
  'with the {n} other lines of this distribution: {sum} %':
    'mit den {n} anderen Zeilen dieser Verteilung: {sum} %',
  'One link on {ref} {name}: {counterpart} · {role} · {quantity} ({year}). Nothing else moves.':
    'Eine Verknüpfung auf {ref} {name}: {counterpart} · {role} · {quantity} ({year}). Sonst bewegt sich nichts.',
  'One link on {ref} {name}: {counterpart} · {role} · {quantity} ({year}), and the {cyear} row ({clabel}) is superseded, undoable. Nothing else moves.':
    'Eine Verknüpfung auf {ref} {name}: {counterpart} · {role} · {quantity} ({year}), und die Zeile {cyear} ({clabel}) wird abgelöst, rückgängig machbar. Sonst bewegt sich nichts.',
  'One link on {ref} {name}: {counterpart} · {role}. Nothing else moves.':
    'Eine Verknüpfung auf {ref} {name}: {counterpart} · {role}. Sonst bewegt sich nichts.',

  // ── round 7 §6.3: eine Personenzelle im Stand ──
  // Der Zellenname und das Wort für ihre Art kommen aus person-raster.v1.ts (personLabelFor,
  // personKindLabel) und stehen NICHT hier — eine zweite Schreibweise wäre eine zweite Wahrheit.
  'cell': 'Zelle',
  'always your click': 'immer Ihr Klick',
  'A birth year or decade, and any value a broker asserted, is never held on arrival: this one waits for a person, whatever the standing instruction says.':
    'Ein Geburtsjahr oder -jahrzehnt und jeder von einem Datenhändler behauptete Wert werden nie bei Eingang übernommen: dieser Vorschlag wartet auf einen Menschen, was die stehende Anweisung auch sagt.',
  'Hold the {n} left anyway': 'Die {n} verbliebenen trotzdem übernehmen',
  'Hold the rows the rule guards too. Each one is written through the same applier and its objection is noted on the row.': 'Auch die von der Regel geschützten Zeilen übernehmen. Jede wird durch denselben Applier geschrieben, und ihr Einwand wird auf der Zeile vermerkt.',
  'Hold the {n} the rule left?': 'Die {n} von der Regel belassenen übernehmen?',
  'Hold them all': 'Alle übernehmen',
  'Each of these was left because the record already answers it. Holding them writes every one through the same applier, and the objection it overruled is written on the row.': 'Jede dieser Zeilen blieb stehen, weil der Datenbestand sie bereits beantwortet. Sie zu übernehmen schreibt jede einzelne durch denselben Applier, und der überstimmte Einwand wird auf die Zeile geschrieben.',
  '{n} of them over the rule’s objection, noted on each row': '{n} davon gegen den Einwand der Regel, auf jeder Zeile vermerkt',
  'Nothing could be held automatically — every one of the {left} is guarded':
    'Nichts konnte automatisch übernommen werden — alle {left} sind geschützt',
  '{n} not reached — press Hold all again':
    '{n} nicht erreicht — «Alle übernehmen» erneut drücken',
  'Why the queue did not move':
    'Warum sich die Warteschlange nicht bewegt hat',
  'Every one of these was left on purpose. They are not errors, and none of them is waiting on the machine — each needs a decision only you can make.':
    'Alle diese wurden bewusst stehen gelassen. Es sind keine Fehler, und keiner wartet auf die Maschine — jeder braucht eine Entscheidung, die nur Sie treffen können.',
  'One of these is the expensive one: a person whose name is already on the record becomes a SECOND row for the same human. A merge now exists (scripts/person-merge-dry-run.ts) and joins two rows onto one survivor, so it is no longer irreversible — but it is a script a person runs and reads, not a click here. Everything else supersedes, chains or can be archived. Narrow the Kind filter first if you want to hold the rest without the people.':
    'Eine davon ist die teure: Eine Person, deren Name bereits im Datenbestand steht, wird zu einer ZWEITEN Zeile für denselben Menschen. Eine Zusammenführung gibt es jetzt (scripts/person-merge-dry-run.ts); sie führt zwei Zeilen auf einen Überlebenden zusammen, also ist es nicht mehr unumkehrbar — aber es ist ein Skript, das ein Mensch ausführt und liest, kein Klick hier. Alles andere wird abgelöst, verkettet oder kann archiviert werden. Grenzen Sie zuerst den Art-Filter ein, wenn Sie den Rest ohne die Personen übernehmen wollen.',
  'Auto-accept…':
    'Automatisch übernehmen…',
  'Choose which kinds of judgement the rule may stop asking about. A waived class is held automatically, on this backlog and on everything that arrives after.':
    'Wählen Sie, welche Arten von Beurteilung die Regel nicht mehr stellen soll. Eine erlassene Klasse wird automatisch übernommen — für diesen Rückstand und für alles, was danach eintrifft.',
  'What may be held without asking you?':
    'Was darf ohne Rückfrage übernommen werden?',
  'Asking the rule about every unheld row…':
    'Die Regel wird zu jeder offenen Zeile befragt…',
  '{unheld} unheld · {holdable} would be held by a plain Hold all today. Each switch below turns off ONE kind of judgement, for this backlog and for everything that arrives after it.':
    '{unheld} offen · {holdable} würden heute von einem einfachen «Alle übernehmen» übernommen. Jeder Schalter unten schaltet EINE Art von Beurteilung ab — für diesen Rückstand und für alles, was danach eintrifft.',
  'held without asking':
    'ohne Rückfrage übernommen',
  'needs you':
    'braucht Sie',
  'Two guards have no switch and never will: birth data filed into a cell that is not the birth cell, and a filing naming no cell, subject or counterpart. Holding either writes something no reader of that cell expects.':
    'Zwei Schutzregeln haben keinen Schalter und werden nie einen haben: Geburtsdaten, die in eine Zelle abgelegt wurden, die nicht die Geburtszelle ist, und eine Meldung, die weder Zelle noch Subjekt noch Gegenpart nennt. Beide zu übernehmen schreibt etwas, das kein Leser dieser Zelle erwartet.',
  'rows are guarded that way now.':
    'Zeilen sind derzeit so geschützt.',
  'The guards could not be counted.':
    'Die Schutzregeln konnten nicht gezählt werden.',
  'The waiver was not saved.':
    'Der Erlass wurde nicht gespeichert.',
  '{n} guard(s) waived. New arrivals in those classes are held without asking.':
    '{n} Schutzregel(n) erlassen. Neueingänge dieser Klassen werden ohne Rückfrage übernommen.',
  'Every guard is back on. Nothing is held without a person.':
    'Alle Schutzregeln sind wieder aktiv. Nichts wird ohne einen Menschen übernommen.',
  'Waiting on an organisation still in Review':
    'Wartet auf eine Organisation, die noch in Prüfung ist',
  'Surfe said it':
    'Surfe hat es behauptet',
  'A birth or age cell':
    'Eine Geburts- oder Alterszelle',
  'An estimate over a value already held':
    'Eine Schätzung über einem bereits übernommenen Wert',
  'A name already on the record':
    'Ein Name, der bereits im Datenbestand steht',
  'A value you typed yourself':
    'Ein Wert, den Sie selbst eingetippt haben',
  'The organisation is held first, in the same click. Nothing is lost — this is only an ordering.':
    'Die Organisation wird im selben Klick zuerst übernommen. Nichts geht verloren — es ist nur eine Reihenfolge.',
  'Surfe’s answer is written as a fact without a person reading it first. It is still marked as Surfe’s and still cites the snapshot.':
    'Surfes Antwort wird als Fakt geschrieben, ohne dass ein Mensch sie zuvor liest. Sie bleibt als Surfes gekennzeichnet und zitiert weiterhin den Snapshot.',
  'Age and birth data go onto the record without a person deciding. You asked for this guard yourself on 07.09.2026; the LPD information duty still applies.':
    'Alters- und Geburtsdaten gelangen in den Datenbestand, ohne dass ein Mensch entscheidet. Sie haben diese Schutzregel am 07.09.2026 selbst verlangt; die Informationspflicht nach DSG gilt weiterhin.',
  'An ESTIMATE supersedes a value already on the record. The old value stays in the history, marked superseded.':
    'Eine SCHÄTZUNG löst einen bereits vorhandenen Wert ab. Der alte Wert bleibt in der Historie, als abgelöst markiert.',
  'A SECOND row is created for a person or organisation whose name is already there. The merge script joins them afterwards; nothing joins them by itself.':
    'Es entsteht eine ZWEITE Zeile für eine Person oder Organisation, deren Name bereits vorhanden ist. Das Zusammenführungs-Skript vereint sie nachträglich; von selbst vereint sie nichts.',
  'A machine reading supersedes a value YOU TYPED. This is the only one that overwrites your own words.':
    'Eine Maschinenlesung löst einen Wert ab, den SIE EINGETIPPT haben. Als einzige überschreibt sie Ihre eigenen Worte.',
}, 'ReviewPage');
